<div class="nf-table-container">
  <table class="nf-table">
    <thead>
      <tr>
        <th *ngFor="let label of columnLabels" class="column-header">
          {{ label }}
        </th>
      </tr>
    </thead>
    <tbody>
      <tr *ngFor="let row of filteredPaginatedData; let i = index"
          [ngClass]="{ 'total-row': row['Grupo'] == '' || row['Grupo'] === ''}">
        <td *ngFor="let column of columnKeys" class="table-cell">
          {{ row[column] }}
        </td>
      </tr>
    </tbody>
  </table>

  <!-- Paginação - APENAS SE showPagination for true -->
  <div class="pagination-container" *ngIf="showPagination && data.length > 0">
    <div class="pagination-content">
      <!-- Seletor de linhas por página -->
      <div class="rows-per-page">
        <label>Linhas por página:</label>
        <select class="page-selector"
                (change)="onPageSizeChange($event)"
                [value]="serverSidePagination ? serverSidePagination.pageSize : pageSize">
          <option value="5">5</option>
          <option value="10">10</option>
          <option value="20">20</option>
          <option value="50">50</option>
          <option value="100">100</option>
        </select>
      </div>

      <!-- Contador de elementos -->
      <div class="page-counter">
        {{ getDisplayedRange() }}
      </div>

      <!-- Navegação -->
      <div class="navigation">
        <button class="nav-button"
                (click)="previousPage()"
                [disabled]="!hasPreviousPage()">
          <img src="assets/icons/arrowBack.png" alt="Anterior" class="nav-icon">
        </button>
        <button class="nav-button"
                (click)="nextPage()"
                [disabled]="!hasNextPage()">
          <img src="assets/icons/arrowNext.png" alt="Próxima" class="nav-icon">
        </button>
      </div>
    </div>
  </div>
</div>
